import React, { useContext } from 'react';
import { Icon } from '@iconify/react';
import { TextsContext } from '../../context/textsContext';
import { TitleH2Component } from '../TitleH2Component';
import { ParagraphComponent } from '../ParagraphComponent';
import style from '../../scss/saveFavoritePlan.module.scss';

/**
 * Estado "success" del diálogo de guardar plan favorito: el plan quedó guardado.
 * Desde este estado el diálogo se cierra solo a los 3s y redirige al dashboard.
 *
 * @param {boolean} isEdit  cambia los textos a "actualizado" en modo edición
 */
const SavedState = ({ isEdit = false }) => {
    const { texts } = useContext(TextsContext);

    return (
        <>
            <Icon icon="mdi:check-circle-outline" width={40} height={40} style={{ color: '#61A60E' }} className={style.icon} />
            <TitleH2Component styleGroup={`raleway color_primary ${style.title}`}>
                {isEdit
                    ? (texts?.favorite_plan_update_success_title ?? 'Plan updated')
                    : (texts?.favorite_plan_save_success_title ?? 'Plan saved')}
            </TitleH2Component>
            <ParagraphComponent styleGroup={`Poppins ${style.text}`}>
                {isEdit
                    ? (texts?.favorite_plan_update_success_text ?? 'Your plan was updated in My Favorite Plans.')
                    : (texts?.favorite_plan_save_success_text ?? 'Your plan was saved to My Favorite Plans.')}
            </ParagraphComponent>
        </>
    );
};

export default SavedState;
